function scrollToHighestElement(elements) {
    let highestElement = null;
    let minTop = Infinity; // Start with a very high value

    // Loop through each element and find the one with the smallest 'top' value
    elements.forEach(element => {
        const rect = element.getBoundingClientRect();
        if (rect.top < minTop) {
            minTop = rect.top;
            highestElement = element;
        }
    });

    // Scroll to the highest element
    if (highestElement) {
        highestElement.scrollIntoView({
            behavior: 'smooth', // Optional: for smooth scrolling
            block: 'start',     // Optional: scroll to the top of the element
        });
    }
}

function scrollToLowestElement(elements) {
    let lowestElement = null;
    let maxBottom = -Infinity; // Start with a very low value

    // Loop through each element and find the one with the highest 'bottom' value
    elements.forEach(element => {
        const rect = element.getBoundingClientRect();
        if (rect.bottom > maxBottom) {
            maxBottom = rect.bottom;
            lowestElement = element;
        }
    });

    // Scroll to the lowest element
    if (lowestElement) {
        lowestElement.scrollIntoView({
            behavior: 'smooth', // Optional: for smooth scrolling
            block: 'end',       // Optional: scroll to the bottom of the element
        });
    }
}

async function initSwiperAfterLibLoad(swiperSelector, swiperOptions){
  const init = () => new Swiper(swiperSelector, swiperOptions);
  
  if (swiperJsScript.dataset.loaded != undefined) return init();
  else {
    await new Promise(function (resolve, reject) {
      swiperJsScript.addEventListener("load", resolve, { once: true });
    });
    return init();
  }
}